import { Dispatch } from "redux";
import { v4 as uuid } from "uuid";
import { Alert } from "../models/alert.model";
import { AlertTypes } from "../utils/alert.utils";
import { SET_ALERT, REMOVE_ALERT } from "./types";

export const setAlert =
  (msg: string, type: AlertTypes, timeout = 5000) =>
    (dispatch: Dispatch) => {
      const id = uuid();
      dispatch({
        type: SET_ALERT,
        payload: new Alert(id, type, msg),
      });

      setTimeout(() => dispatch({ type: REMOVE_ALERT, payload: id }), timeout);
    };
